import * as types from './action-types';

export function beginApiCall() {
    return { type: types.BEGIN_API_CALL };
}

export function apiCallError(error) {
    return { type: types.API_CALL_ERROR, error };
}

export function apiCallStateReset(error) {
    return { type: types.API_CALL_STATE_RESET, error };
}
